<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Checkbox, Alert } from '@Shelly/shelly-design-system';
	//Types
	import type { PeripheralDigitalSettings } from 'src/types/Peripherals';

	let className = 'mb-s';
	export { className as class };

	export let settings: PeripheralDigitalSettings;
</script>

<div class={className}>
	{#if settings.enable != null}
		<Checkbox size="m" bind:checked={settings.enable} id="checkbox-lvczacf"
			>{$format('sub_settings_title_enable_input', {
				default: 'Enable input',
			})}</Checkbox
		>
	{/if}
	<Checkbox size="m" bind:checked={settings.factory_reset} id="checkbox-m2pplx4"
		>{$format('peripherals_factory_reset', {
			default: 'Enable factory reset from input (0)',
		})}</Checkbox
	>
	<Checkbox size="m" bind:checked={settings.invert} id="checkbox-d3b0e3q"
		>{$format('peripherals_enable_invert_input', {
			default: 'Enable invert input',
		})}</Checkbox
	>
	<Alert
		type="info"
		isHeadingBold
		heading={$format('label_info')}
		message={$format('alert_message_invert_digital_input_invert_info', {
			default:
				'For the change to be applied, the physical switch has to be toggled once after invert is set.',
		})}
	/>
</div>
